"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceAccessInfoRole = void 0;
exports.ResourceAccessInfoRole = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
